import { ITableColumnMetadata } from '../../components/CustomTable/interfaces';

const tableColumnMetadata: ITableColumnMetadata[] = [
  { key: 'name', displayName: 'Tipo de formulario' },
  { key: 'url', displayName: 'URL', type: 'url' },
  {
    key: 'id',
    displayName: 'Acción',
    type: 'action',
    actions: ['EXPORT']
  }
];

export default tableColumnMetadata;
